export default __webpack_public_path__ + "static/mockup-iphone-store@3x-b37fd1dc104b15f851601b83643451ba.png";